import {
  Component, ContentChild, ViewChild, Input, Output, EventEmitter, OnChanges
  , SimpleChanges, DoCheck
} from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { CriteriaAddComponent } from '../criteria/criteria.add.component';

@Component({
  selector: "crtieria-conditions-form",
  template: `<ng-container [formGroup]="formGroup1">
    <div *ngIf="displayForm" class="form-group grey-bg criteria-add brd-left-green questions-cr qu-radios-pos mt-5">
       <input formControlName="formTitle" class="form-control grey-bg input-borderless m-2" placeholder="Condition titre" value=""
       [(ngModel)]="titleText" [ngClass]="showTextInvalid? 'input-empty':''" (ngModelChange)="titleChange($event)">
        <hr class="hr-input m-2" />
        <div class="bx-icon2 ft-dark-grey" (click)="deleteElement()">
          <span class="oi oi-x"></span>
        </div>
        <div class="form-group criteria-add m-2">
            <div class="radios-pos">
            <label class="custom-control custom-radio radio-middle">
                <input formControlName="formRadio" type="radio" class="custom-control-input" value="1" [checked]="selectedRadio==1" (click)="addConditionTemplate(1)">
                <span class="custom-control-indicator"></span>
                <span class="custom-control-description small ft-weight500" [ngClass]="(selectedRadio == 0)? 'grey40': (selectedRadio!=1)? 'grey99':'grey40'">Désirable</span>
            </label>
                <label class="custom-control custom-radio radio-middle">
                <input formControlName="formRadio" type="radio" class="custom-control-input" value="2" [checked]="selectedRadio==2" (click)="addConditionTemplate(2)">
                <span class="custom-control-indicator"></span>
                <span class="custom-control-description small ft-weight500" [ngClass]="(selectedRadio == 0)? 'grey40': (selectedRadio!=2)? 'grey99':'grey40'">Souhaitable</span>
            </label>
                <label class="custom-control custom-radio radio-middle">
                <input formControlName="formRadio" type="radio" class="custom-control-input" value="3" [checked]="selectedRadio==3" (click)="this.addConditionTemplate(3)">
                <span class="custom-control-indicator"></span>
                <span class="custom-control-description small ft-weight500" [ngClass]="(selectedRadio == 0)? 'grey40': (selectedRadio!=3)? 'grey99':'grey40'">Acceptable</span>
            </label>
                <label class="custom-control custom-radio radio-middle">
                <input formControlName="formRadio" type="radio" class="custom-control-input" value="4" [checked]="selectedRadio==4" (click)="addConditionTemplate(4)">
                <span class="custom-control-indicator"></span>
                <span class="custom-control-description small ft-weight500" [ngClass]="(selectedRadio == 0)? 'grey40': (selectedRadio!=4)? 'grey99':'grey40'">Inacceptable</span>
            </label>
            </div>
        </div>
    </div>
  </ng-container>
`
})
export class CriteriaFormComponent implements OnChanges, DoCheck {
  @Input() editValues: Array<any>;
  @Input() formNumber: number;
  @Input() displayArray: Array<any>;
  @Input() allValid: number;

  @Output() formOutput: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();
  @Output() elementDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() formError: EventEmitter<number> = new EventEmitter<any>();
  formGroup1: FormGroup;
  formTitle: FormControl;
  formRadio: FormControl;
  selectedRadio = 0;
  titleText = '';
  displayForm = true;
  previousErrors: Array<any> = [];
  firstFormStates: Array<any> = [];

  showTextInvalid = false;
  constructor(private formBuilder: FormBuilder) {
    this.formTitle = new FormControl('', Validators.required);
    this.formRadio = new FormControl('');
    this.formGroup1 = new FormGroup({ 'formTitle': this.formTitle, 'formRadio': this.formRadio });
    this.firstFormStates.push('1');
  }

  addConditionTemplate(radioValue) {
    this.selectedRadio = radioValue;
    const formTitle = this.titleText;
    const formNumber = this.formNumber;
    if (formTitle === '' && radioValue > 0) {
      this.previousErrors.push('0');    // push false validation to enable button
      this.showTextInvalid = true;
    } else {
      this.showTextInvalid = false;
      this.previousErrors.push('1');    // push true validation to enable button
      this.formOutput.emit([{ formTitle, radioValue, formNumber }]);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.editValues) {
      const formEditItem = this.editValues.filter(x => x.addIndex === this.formNumber)[0];
      if (formEditItem) {
        this.titleText = formEditItem.title;
        this.selectedRadio = formEditItem.importance;
      }
    }
    if (this.showTextInvalid === true) {
      this.formError.emit(1);
    } else if (changes['showTextInvalid'].currentValue === false && changes['showTextInvalid'].previousValue === true) {
      this.formError.emit(0);  // emit true valid to the form
    }
    if (this.allValid === 1) {  // if deleted a form and all forms are valid
      this.previousErrors.push('1');  // push true validation
    }
  }

  ngDoCheck() {
    if (this.displayArray && this.displayArray[0]) { // hide First condition form
      if (this.displayArray[0].display === 0 && this.firstFormStates[this.firstFormStates.length - 1] === '1') {
        this.firstFormStates.push('0');   // push hide to hide firstItem because ngDoCheck&ngOnChanges detect not firstitem in dispalyArray
        this.displayForm = false;
      }
    }
    if (this.displayArray && this.formNumber) {
      const formDisplayItem = this.displayArray.filter(x => x.index === this.formNumber)[0];
      if (formDisplayItem) {
        this.displayForm = (formDisplayItem.display === 0) ? false : true;
      }
    }
    if (this.previousErrors.length > 0) {
      const lastItem = this.previousErrors[this.previousErrors.length - 1];
      if (this.previousErrors.length > 1) {
        const previousState = this.previousErrors[this.previousErrors.length - 2];
        if (lastItem === '1' && previousState === '0') {
          this.formError.emit(0);  // emit true valid to the form
        }
      }
      if (lastItem === '0') {
        this.formError.emit(1);  // emit false valid to the form
      }
    }
  }

  titleChange(refValue) {
    if ((!refValue || refValue === '') && this.selectedRadio > 0) {
      this.previousErrors.push('0');  // push error
      this.showTextInvalid = true;
    } else {
      this.previousErrors.push('1');  // push true validation
      this.showTextInvalid = false;
      this.addConditionTemplate(this.selectedRadio);
    }
  }

  deleteElement() {
    this.titleText = '';
    this.elementDeleted.emit(this.formNumber);
  }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/criteria/criteria.form.component.ts